module.exports = __webpack_public_path__ + "static/media/secure-mail.0d2899e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/secure-mail.png
// module id = 13914
// module chunks = 0